import PropTypes from 'prop-types';
import React from 'react';
import { updateGradebook } from '../../../../actions/gradebook';
import styles from './FilterSection.module.css';

export const IFilterSection = {
  visibleFilter: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

function setVisible(dispatch, section) {
  dispatch(
    updateGradebook({
      visibleFilterSection: section,
    }),
  );
}

export const ToggleButton = ({ dispatch, visibleFilter, id }) => {
  if (visibleFilter === id) {
    return (
      <button
        data-test-id={`${id}-hide`}
        className={styles.toggleButton}
        tabIndex={0}
        onClick={() => {
          setVisible(dispatch, '');
        }}
      >
        Hide
      </button>
    );
  }
  return (
    <button
      data-test-id={`${id}-show`}
      className={styles.toggleButton}
      tabIndex={0}
      onClick={() => {
        setVisible(dispatch, id);
      }}
    >
      Show
    </button>
  );
};

ToggleButton.propTypes = {
  ...IFilterSection,
  dispatch: PropTypes.func.isRequired,
};

// component Body
export const Body = ({ visibleFilter, id, children }) => {
  if (visibleFilter === id) {
    return children;
  }
  return null;
};
Body.propTypes = {
  ...IFilterSection,
};

// component Header
export const Header = ({ id, dispatch, visibleFilter, headerText }) => (
  <header className={styles.header}>
    <span className={styles.headerText}>{headerText}</span>
    <ToggleButton visibleFilter={visibleFilter} dispatch={dispatch} id={id} />
  </header>
);

Header.propTypes = {
  ...IFilterSection,
  dispatch: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
};

const FilterSection = ({
  visibleFilter,
  dispatch,
  id,
  headerText,
  children,
}) => (
  <section>
    <Header
      visibleFilter={visibleFilter}
      dispatch={dispatch}
      headerText={headerText}
      id={id}
    />
    <Body visibleFilter={visibleFilter} id={id}>
      <div className={styles.body}>{children}</div>
    </Body>
  </section>
);

FilterSection.propTypes = {
  ...IFilterSection,
  dispatch: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
};

export default FilterSection;
